
define('template!ordersBoardFiltersLanguageView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (hasLanguages) { ;
__p += '\n<select class="language-dropdown">\n    ';
 _.each(languages, function(lang) { ;
__p += '\n    <option value="' +
((__t = ( lang.code )) == null ? '' : __t) +
'" ';
 if (selectedLanguage === lang.code) { ;
__p += 'selected';
 } ;
__p += '>' +
((__t = ( lang.label )) == null ? '' : __t) +
'</option>\n    ';
 }); ;
__p += '\n</select>\n';
 } ;
__p += '\n';

}
return __p
};});

